import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";

export type PublicRouteProps = {
  authenticationPath?: string;
  outlet?: React.ReactElement;
};

export default function PublicRoute({
  authenticationPath = "/home",
  outlet,
}: PublicRouteProps) {
  const tableId = localStorage.getItem("table_id");
  if (!tableId) {
    return <Navigate to="/scan" replace />;
  }

  if (localStorage.getItem("access_token")) {
    return <Navigate to={authenticationPath} replace />;
  } else {
    return outlet ? outlet : <Outlet />;
  }
}
